module.exports = __webpack_public_path__ + "public/SiteIcons/mailDark.png?e3f8a12a";